<template>
    <div class="my-ct-body category-tag-detail-page" v-title :data-title="title">
        <el-container class="my-ct-container">
            <el-main>
                <!-- 返回列表 + Tab 切换 -->
                <div class="my-ct-nav">
                    <router-link :to="`/${$route.params.type}/all`" class="back-link">
                        <i class="el-icon-arrow-left"></i> 返回{{ $route.params.type === 'tag' ? '标签' : '文章分类' }}
                    </router-link>
                </div>
                <div class="my-ct-title cyber-glass-header">
                    <!--标签-->
                    <template v-if="this.$route.params.type === 'tag'">
                        <img class="my-ct-picture" :src="ct.avatar?ct.avatar:defaultAvatar"/>
                        <h3 class="my-ct-name">{{ct.tagName}}</h3>
                    </template>
                    <!--种类-->
                    <template v-else>
                        <img class="my-ct-picture" :src="ct.avatar?ct.avatar:defaultAvatar"/>
                        <h3 class="my-ct-name">{{ct.categoryName}}</h3>
                        <p>{{ct.description}}</p>
                    </template>
                    <!--对应的文章数量-->
                    <span class="my-ct-meta">{{ct.articlesNumber}} 篇文章</span>
                </div>

                <!--分页组件-->
                <div class="my-ct-articles">
                    <article-scroll-page :query="query"></article-scroll-page>
                </div>

            </el-main>
        </el-container>
    </div>
</template>

<script>
    import defaultAvatar from '@/assets/img/logo.png'
    import ArticleScrollPage from "@/components/common/ArticleScrollPage"
    import {getTagDetailById} from "@/api/tag"
    import {getCategoryDetailById} from "@/api/category"

    export default {
        name: "BlogCategoryTagDetail",

        data() {
            return {
                defaultAvatar: defaultAvatar,
                ct: {},
                query: {
                    tagId: null,
                    categoryId: null
                }
            }
        },
        created() {
            //进行后端请求 请求数据
            this.getCategoryOrTagAndArticles();
        },
        methods: {
            /*请求分类详情或者标签详情数据*/
            getCategoryOrTagAndArticles() {
                let type = this.$route.params.type;
                let id = this.$route.params.id;
                if ('tag' === type) {
                    this.getTagDetailById(id);
                    this.query.tagId = id;
                }
                if ('category' === type) {
                    this.getCategoryDetailById(id);
                    this.query.categoryId = id;
                }
            },
            getTagDetailById(id) {
                //发起http请求 请求标签详情
                getTagDetailById(id).then((res) => {
                    ////res.data = Result (success,msg,data)
                    if (res.data.success) {
                        this.ct = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch((err) => {
                    this.$message.error("系统错误");
                }).finally(() => {
                })
            },
            getCategoryDetailById(id) {
                //发起http请求 请求分类详情
                getCategoryDetailById(id).then((res) => {
                    ////res.data = Result (success,msg,data)
                    if (res.data.success) {
                        this.ct = res.data.data;
                    } else {
                        this.$message.error(res.data.msg);
                    }
                }).catch((err) => {
                    this.$message.error("系统错误");
                }).finally(() => {
                })
            }
        },
        computed: {
            title() {
                if (this.$route.params.type === 'tag') {
                    return "标签详情"
                } else {
                    return "文章分类详情"
                }
            }
        },
        components: {
            "article-scroll-page": ArticleScrollPage
        }
    }
</script>

<style scoped>
    .my-ct-body {
        margin: 40px auto 56px;
        min-width: 100%;
    }

    .my-ct-nav {
        margin-bottom: 16px;
    }

    .my-ct-nav .back-link {
        display: inline-flex;
        align-items: center;
        color: rgba(0, 255, 245, 0.9);
        font-size: 14px;
        text-decoration: none;
        transition: all 0.25s ease;
    }

    .my-ct-nav .back-link:hover {
        color: #00fff5;
        text-shadow: 0 0 10px rgba(0, 255, 245, 0.5);
    }

    .my-ct-container {
        max-width: 900px;
        margin: 0 auto;
    }

    .my-ct-container .el-main {
        padding: 0;
    }

    /* 赛博朋克玻璃风标题区 */
    .my-ct-title.cyber-glass-header {
        text-align: center;
        min-height: 150px;
        padding: 28px 20px;
        background: rgba(10, 15, 28, 0.5);
        backdrop-filter: blur(16px);
        -webkit-backdrop-filter: blur(16px);
        border: 1px solid rgba(0, 255, 245, 0.2);
        border-radius: 12px;
        margin-bottom: 24px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.05);
    }

    .my-ct-picture {
        width: 60px;
        height: 60px;
        filter: drop-shadow(0 0 10px rgba(0, 255, 245, 0.3));
    }

    .my-ct-name {
        font-size: 28px;
        font-weight: 600;
        color: rgba(224, 242, 254, 0.98);
    }

    .my-ct-title p {
        color: rgba(203, 213, 225, 0.85);
        font-size: 14px;
        margin-top: 8px;
    }

    .my-ct-meta {
        font-size: 12px;
        color: rgba(148, 163, 184, 0.9);
    }

    .my-ct-articles {
        width: 640px;
        max-width: 95vw;
        margin: 30px auto;
    }
</style>
